import React, { useEffect } from 'react';
import PendoService from '@Services/Pendo';
import { helpUrl } from '@Constants/CommonConstants';
import { ButtonWithIcon } from '@els/els-react--button';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import HoverTooltip from '@Components/HoverTooltip';

import './Help.scss';

function Help({ isPendoResourceCenterEnabled }) {
  const doNotTrack = window._doNotTrackBrowser;

  useEffect(() => {
    // Only add window listener to close when clicking outside
    window.addEventListener('click', PendoService.closeResourceCenter);
    return () => {
      window.removeEventListener('click', PendoService.closeResourceCenter);
    };
  }, []);

  const handleHelpClick = (e) => {
    if (isPendoResourceCenterEnabled && !doNotTrack) {
      e.stopPropagation();
    }
  };

  return (
    <li className="u-els-padding-left-1o2">
      <a
        id="main-nav-help-link"
        aria-label="Help"
        target="_blank"
        href={!isPendoResourceCenterEnabled || doNotTrack ? helpUrl : undefined}
        onClick={handleHelpClick}
        className="u-els-color-n8 vertical-middle rx-btn-help c-els-position-relative"
        rel="noreferrer">
        <HoverTooltip id="resource-center-tooltip" tooltip="Resource Center" tooltipPlace="bottom-end" theme="simple">
          <ButtonWithIcon type="borderless" iconOnly sprite="HelpOutlineCircle" onClick={noop} a11y={{ name: 'help' }} id="help-icon">
            Resource Center
          </ButtonWithIcon>
        </HoverTooltip>
      </a>
    </li>
  );
}

Help.propTypes = {
  isPendoResourceCenterEnabled: PropTypes.bool,
};

export default Help;
